import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const LLBCoursePage: React.FC = () => {
  const courseData = {
    title: "LLB/BA LLB (Bachelor of Laws)",
    shortName: "LLB",
    duration: "3-5 years",
    description: "Professional law program for legal practice, advocacy, and judicial services",
    overview: "Bachelor of Laws (LLB) is a professional law degree program available as 3-year course (after graduation) or 5-year integrated BA LLB program (after 12th). This course provides comprehensive knowledge of Indian legal system, constitutional law, civil and criminal procedures, and legal practice, preparing students for careers in legal profession, judiciary, and corporate legal services.",
    eligibility: [
      "For 3-year LLB: Bachelor's degree from recognized university",
      "For 5-year BA LLB: 10+2 from recognized board",
      "Minimum 50% marks (45% for SC/ST)",
      "Valid CLAT/LSAT/University entrance exam scores",
      "Age limit: 20 years (5-year) / 30 years (3-year)"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Legal Methods & Jurisprudence",
          "Constitutional Law of India",
          "Law of Contracts",
          "Political Science (for BA LLB)",
          "English & Legal Language",
          "Economics (for BA LLB)"
        ]
      },
      {
        year: 2,
        subjects: [
          "Criminal Law",
          "Law of Torts",
          "Family Law",
          "Property Law",
          "Administrative Law",
          "Legal Writing & Research"
        ]
      },
      {
        year: 3,
        subjects: [
          "Civil Procedure Code",
          "Criminal Procedure Code",
          "Company Law",
          "Labor & Industrial Law",
          "Environmental Law",
          "Internship & Practical Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Advocate/Lawyer",
        "Legal Advisor",
        "Corporate Counsel",
        "Judicial Services Officer",
        "Legal Analyst",
        "Compliance Officer",
        "Legal Journalist",
        "Legal Researcher",
        "Arbitrator/Mediator",
        "Public Prosecutor"
      ],
      industries: [
        "Law Firms",
        "Corporate Legal Departments",
        "Judiciary & Courts",
        "Government Legal Services",
        "Banking & Financial Services",
        "Insurance Companies",
        "Real Estate Companies",
        "Media & Entertainment",
        "International Organizations",
        "Legal Process Outsourcing"
      ],
      averageSalary: "₹3-8 LPA (Fresher), ₹12-50+ LPA (Experienced)",
      topRecruiters: [
        "Amarchand Mangaldas",
        "Khaitan & Co",
        "Cyril Amarchand Mangaldas",
        "J.Sagar Associates",
        "Corporate Legal Departments",
        "Government Legal Services"
      ]
    },

    admissionProcess: [
      "CLAT (Common Law Admission Test)",
      "LSAT India",
      "University-specific entrance exams",
      "Merit-based admission",
      "Counseling and seat allotment",
      "Document verification and fee payment"
    ],

    topColleges: [
      {
        name: "National Law School of India",
        location: "Bangalore",
        fees: "₹2.5 Lakhs",
        ranking: "NIRF Ranking: 1"
      },
      {
        name: "National Academy of Legal Studies",
        location: "Hyderabad",
        fees: "₹3 Lakhs",
        ranking: "NIRF Ranking: 2"
      },
      {
        name: "West Bengal National University",
        location: "Kolkata",
        fees: "₹1.5 Lakhs",
        ranking: "NIRF Ranking: 3"
      },
      {
        name: "Tamil Nadu Dr. Ambedkar Law University",
        location: "Chennai",
        fees: "₹1.2 Lakhs",
        ranking: "State Law University"
      }
    ],

    lawColleges: {
      government: [
        { slNo: 1, name: "Chennai Dr. Ambedkar Government Law College", location: "Pattarai Perambudur, Thiruvallur Taluk & District - 631 203", type: "Government" },
        { slNo: 2, name: "Chennai Dr. Ambedkar Government Law College", location: "Pudupakkam, Thiruporur Taluk, Chengalpattu District - 631 203", type: "Government" },
        { slNo: 3, name: "Government Law College", location: "Madurai – 625 020", type: "Government" },
        { slNo: 4, name: "Government Law College", location: "Trichirappalli – 620 023", type: "Government" },
        { slNo: 5, name: "Government Law College", location: "Coimbatore – 641 046", type: "Government" },
        { slNo: 6, name: "Government Law College", location: "Tirunelveli – 627 011", type: "Government" },
        { slNo: 7, name: "Government Law College", location: "Chengalpattu – 603 001", type: "Government" },
        { slNo: 8, name: "Government Law College", location: "Vellore – 632 006", type: "Government" },
        { slNo: 9, name: "Government Law College", location: "Villupuram – 605 603", type: "Government" },
        { slNo: 10, name: "Government Law College", location: "Dharmapuri – 636 701", type: "Government" },
        { slNo: 11, name: "Government Law College", location: "Ramanathapuram – 623 501", type: "Government" },
        { slNo: 12, name: "Government Law College", location: "Salem - 636 010", type: "Government" },
        { slNo: 13, name: "Government Law College", location: "Namakkal - 637 001", type: "Government" },
        { slNo: 14, name: "Government Law College", location: "Theni - 625 534", type: "Government" },
        { slNo: 15, name: "Government Law College", location: "Karaikudi - 630 003", type: "Government" }
      ],
      private: [
        { slNo: 1, name: "Central Law College", location: "Salem - 636 008", type: "Private" },
        { slNo: 2, name: "Saraswathy Law College", location: "Tindivanam", type: "Private" },
        { slNo: 3, name: "Mother Teresa Law College", location: "Pudukottai District - 622 102", type: "Private" },
        { slNo: 4, name: "G.T.N Law College", location: "Dindigul District - 624 005", type: "Private" },
        { slNo: 5, name: "KMC College of Law", location: "Tiruppur District - 641 605", type: "Private" },
        { slNo: 6, name: "Erode College of Law", location: "Erode District - 638 453", type: "Private" },
        { slNo: 7, name: "S.Thangapazham Law college", location: "Tenkasi District - 627 758", type: "Private" },
        { slNo: 8, name: "Thulasi College of Law for Women", location: "Tuticorin District - 628 252", type: "Private" },
        { slNo: 9, name: "Mugil College of Law", location: "Kanyakumari District - 629 172", type: "Private" },
        { slNo: 10, name: "Sir Issac Newton Law College", location: "Nagapattinam - 611 001", type: "Private" },
        { slNo: 11, name: "S K P Law College", location: "Tiruvannamalai - 606 611", type: "Private" },
        { slNo: 12, name: "Anandam Law College", location: "Thanjavur - 613 402", type: "Private" }
      ]
    },

    skills: [
      "Legal Research & Analysis",
      "Oral & Written Advocacy",
      "Critical Thinking",
      "Case Law Interpretation",
      "Legal Drafting",
      "Negotiation Skills",
      "Client Counseling",
      "Court Procedures",
      "Legal Ethics",
      "Public Speaking"
    ],

    futureScope: "Growing opportunities in corporate law, intellectual property, cyber law, environmental law, and international arbitration with increasing business complexities and legal awareness.",

    faqs: [
      {
        question: "What is the difference between 3-year and 5-year LLB?",
        answer: "3-year LLB is for graduates, while 5-year BA LLB is integrated program after 12th. Both lead to same legal qualification, but 5-year program provides broader liberal arts education."
      },
      {
        question: "Can I practice as a lawyer immediately after LLB?",
        answer: "After completing LLB, you need to enroll with State Bar Council, complete internship requirements, and pass the All India Bar Examination (AIBE) to practice as an advocate."
      },
      {
        question: "What are the opportunities in corporate law?",
        answer: "Corporate law offers high-paying opportunities in mergers & acquisitions, securities law, corporate compliance, contracts, and legal advisory roles in multinational companies."
      },
      {
        question: "Can I pursue judicial services after LLB?",
        answer: "Yes, you can appear for judicial services examinations conducted by High Courts after completing LLB and fulfilling the required experience criteria."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default LLBCoursePage;
